import React from 'react';
import AriesButton from './AriesButton';

/**
 * AriesOutlinePrimaryButton - outlined green pill (transparent background,
 * green border + green text). Inherits AriesButton behavior and locks the
 * `outline-primary` variant. Used for list-row primary actions that sit on a
 * white card (e.g. Jobs Due "Start").
 */
const AriesOutlinePrimaryButton = (props) => (
  <AriesButton {...props} variant="outline-primary" />
);

export default AriesOutlinePrimaryButton;
